import get from 'lodash/get'

import { BaseOptionType } from '../types'

export const defaultGetOptionId = (option?: BaseOptionType) => get(option, 'id', '')
export const defaultGetOptionName = (option?: BaseOptionType) => get(option, 'name', '')
export const defaultLoadingMessage = 'Загрузка...'
